import { Component, Input, OnInit } from "@angular/core";
import { UITextMode } from "../ui-text/ui-text-mode.enum";

export type UIIconName = 'chevron-down' | 'chevron-up' | 'chevron-left' | 'chevron-right'
    | 'external-link' | 'columns' | 'page-view' | 'select' | 'setup-preferences' |
    'ellipsis-horizontal' | 'ellipsis-vertical' | 'settings' | 'search' | 'page' |
    'arrow-up' | 'arrow-down' | 'upload' | 'arrow-turn' | 'ship' | 'barcode' | 'caution' |
    'critical' | 'air' | 'check' | 'transfer' | 'plus' | 'minus' | 'trash' | 'success' | 'location'
    | 'close' | 'hamburger' | 'marketplace' | 'comment' | 'amazon' | 'walmart' | 'ebay' | 'shopify' | 'etsy'
    | 'purchasing' | 'marketing' | 'tracking' | 'reports' | 'shipping' | 'edit';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'ui-icon',
    templateUrl: './ui-icon.component.html'
})
export class UIIconComponent implements OnInit {
    @Input() icon: UIIconName;
    @Input() mode: UITextMode | string = UITextMode.default;
    @Input() size: 'small' | 'medium' | 'large';
    @Input() label: string;
    get ngClass() {
        return {
            '≈fill-default-text': this.modeIs(UITextMode.default),
            '≈fill-subdued-text': this.modeIs(UITextMode.subdued),
            '≈fill-disabled-text': this.modeIs(UITextMode.disabled),
            '≈fill-critical-text': this.modeIs(UITextMode.critical),
            '≈fill-warning-text': this.modeIs(UITextMode.warning),
            '≈fill-success-text': this.modeIs(UITextMode.success),
            '≈fill-highlight-text': this.modeIs(UITextMode.highlight),
            '≈fill-primary-text': this.modeIs(UITextMode.primary),
            '≈fill-over-critical': this.modeIs(UITextMode.overCritical),
            '≈fill-over-interactive': this.modeIs(UITextMode.overInteractive),
            '≈fill-over-primary': this.modeIs(UITextMode.overPrimary),
        }
    };

    ngOnInit(): void {
    }

    modeIs(mode: UITextMode | string): boolean {
        return mode === this.mode || UITextMode[mode] === this.mode;
    }

    iconIs(icon: UIIconName): boolean {
        return icon === this.icon;
    }

}
